import React from 'react';
import ReactDOM from 'react-dom';

define([
  'globals',
  'jquery',
  'header-view-model',
  'select-element-content',
  'scroll-to-top',
  'internal-user-sticky',
  'accordion',
  'tabs',
  'sticky-kit',
  'perfect-scrollbar',
  'internal-user-sticky'],
function (globals, $, HeaderViewModel) {
  const lozad = require('lozad');

  new HeaderViewModel();
  lozad(document.querySelectorAll('.lozad'),{
    rootMargin: '200px 0px',
  }).observe();

  lozad(document.querySelectorAll('#jb-site-hours'), {
    rootMargin: '200px 0px',
    loaded: () => {
      import(/* webpackChunkName: 'footer_jb' */ '../../footer/jb').then((module) => {
        const getFooterData = module.default;
        getFooterData();
      });
      import(/* webpackChunkName: "enews" */ '../../../../../javascript/_shared/components/Enews').then((module) => {
        const Enews = module.default;
        ReactDOM.render(<Enews mode="dark" />, document.getElementById('gcc-enews'));
      });
    },
  }).observe();

  $(function() {
    $('.jb-header-menu-parent-item').on('click', function() {
      if ($(this).hasClass('shutters')) {
        window.location.href = '/shutters';
      } else if ($(this).hasClass('help')) {
        $(this).find('a:first-child').trigger('click');
      } else if (window.innerWidth < 1170) {
        $(this).find('.jb-header-submenu').toggle();
      }
    });
  });

  $('.jb-header').stick_in_parent();
  $('.jb-header-show-menu').on('click', () => {
    $('#jb-header-show-menu').prop('checked', !$('#jb-header-show-menu').prop('checked'));
    $('.ft-product-cta').toggle();
  });

  // Iterate trust boosters
  const tb = $('.jb-header-tb');
  let tbIndex = -1;
  const showNextTrustBooster = () => {
    ++tbIndex;
    tb.eq(tbIndex % tb.length)
      .fadeIn(500)
      .delay(8000)
      .fadeOut(500, showNextTrustBooster);
  }
  showNextTrustBooster();

  if (!location.pathname.includes('/Catalog/Configurator')) {
    import(/* webpackChunkName: "modals" */ '../../../../../javascript/_shared/modals').then((module) => {
      const { ThemeProvider } = require('styled-components');
      const { theme } = require('../../../../../javascript/jb/theme');
      const Modals = module.default;
      ReactDOM.render(<ThemeProvider theme={theme}><Modals /></ThemeProvider>, document.getElementById('jb-modals'));
    });
  }
});
